import { PTTGroup } from '../../../../../types/PTTGroup';
import { Device } from '../../../../../types/Device';
import { MenuIcons } from '../../consts/MenuIcons';
import React, { useState } from 'react';
import { ReactComponent as DownImg } from 'utils/app/assets/icons/Down.svg';
import { ReactComponent as UpImg } from 'utils/app/assets/icons/Up.svg';
import { Badge } from 'antd';
import { PTTMessage } from '../../api/usePttMessageStore';

export const CustomSubMenu = ({
    group,
    devices,
    selectedGroup,
    selectedDevice,
    onSelect,
    renderStatusDot,
    unreadCounts,
    renderMenuIcon,
}: {
    group: PTTGroup | null;
    devices?: Device[];
    selectedGroup: PTTGroup | null;
    selectedDevice: Device | null;
    unreadCounts: Record<string, number>;
    onSelect: (group: PTTGroup | null, device?: Device) => void;
    renderStatusDot: (online: boolean) => JSX.Element;
    renderMenuIcon: (type: keyof typeof MenuIcons, online?: boolean) => JSX.Element;
}) => {
    const [isOpen, setIsOpen] = useState(false);
    // console.log(group);
    // Определяем, является ли текущая группа выбранной
    const isSelected = devices
        ? selectedGroup === null && selectedDevice === null // Для "Все устройства"
        : selectedGroup?.uid === group?.uid; // Для обычных групп

    // Определяем, является ли группа "Все устройства"
    const isAllDevicesGroup = !!devices;

    return (
        <li
            className={`ant-menu-submenu ant-menu-submenu-inline ${
                isSelected ? 'ant-menu-submenu-selected' : ''
            }`}
        >
            <div
                className="ant-menu-submenu-title"
                onClick={() => {
                    if (isSelected) {
                        // Если группа уже выбрана - переключаем открытие/закрытие
                        setIsOpen(!isOpen);
                    } else {
                        // Выбираем группу и открываем её
                        setIsOpen(true);
                        onSelect(isAllDevicesGroup ? group : group);
                    }
                }}
            >
                <span
                    className={'body medium-bold'}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'var(--primary)',
                    }}
                >
                    {isAllDevicesGroup ? renderMenuIcon('group') : renderMenuIcon('device')}
                    {isAllDevicesGroup ? 'Все доступные устройства (несортированные)' : group?.name}
                    {unreadCounts[group?.uid || ''] > 0 && (
                        <Badge
                            style={{ marginLeft: 4, marginBottom: 2 }}
                            count={unreadCounts[group?.uid || '']}
                        />
                    )}
                </span>
                {isOpen ? (
                    <DownImg width={20} height={12} style={{ fill: 'var(--primary)' }} />
                ) : (
                    <UpImg width={20} height={12} style={{ fill: 'var(--primary)' }} />
                )}
            </div>
            {isOpen && (
                <ul className="ant-menu ant-menu-sub ant-menu-inline">
                    {(devices || group?.devices)?.map((device) => (
                        <li
                            key={device.UID}
                            className={`ant-menu-item ${
                                selectedDevice?.UID === device.UID ? 'ant-menu-item-selected' : ''
                            }`}
                            onClick={() => onSelect(isAllDevicesGroup ? null : group, device)}
                        >
                            <span className={'ant-menu-title-content'} style={{ paddingLeft: 32 }}>
                                <span>{renderStatusDot(device.online)}</span>
                                {device.name || device.DID}
                                {unreadCounts[device.UID] > 0 && (
                                    <Badge
                                        style={{ marginLeft: 4, marginBottom: 2 }}
                                        count={unreadCounts[device.UID]}
                                    />
                                )}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};
